import { Button } from 'src/components';

type Props = {
  isLoading: boolean;
  label?: string;
  handleSubmit: () => void;
};

export default function SubmitButton({
  isLoading,
  label = 'Save',
  handleSubmit,
}: Props) {
  return (
    <Button
      type="button"
      label={label}
      disabled={isLoading}
      onClick={handleSubmit}
    />
  );
}
